import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ISelectOption } from '@lsq-frontend/common-ui';
import { ModalService } from '@lsq-frontend/common-ui';

@Component({
    selector: 'invite-prospect-modal',
    styleUrls: ['./invite-prospect-modal.component.scss'],
    template: ` <form [formGroup]="formGroup">
        <div class="formWrapper">
            <div class="row">
                <div class="col-6">
                    <lsq-input
                        formControlName="contactFirstName"
                        [name]="'first-name'"
                        label="Contact First Name*"
                        i18n-label="First Name input"
                        [group]="formGroup"
                    >
                    </lsq-input>
                </div>
                <div class="col-6">
                    <lsq-input
                        formControlName="contactLastName"
                        [name]="'last-name'"
                        label="Contact Last Name*"
                        i18n-label="Last Name input"
                        [group]="formGroup"
                    >
                    </lsq-input>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <lsq-input
                        formControlName="businessName"
                        [name]="'business-name'"
                        label="Business Name*"
                        i18n-label="Business Name input"
                        [group]="formGroup"
                    >
                    </lsq-input>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <lsq-input
                        formControlName="contactEmail"
                        [name]="'email-address'"
                        label="Contact Email*"
                        i18n-label="Email input"
                        [group]="formGroup"
                    >
                    </lsq-input>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <lsq-select
                        id="contact-type-select"
                        [disabled]="contactTypeDisabled"
                        [options]="filterOptions"
                        [formControlName]="'prospectSchemaId'"
                        [group]="formGroup"
                        label="Contact Type*"
                    >
                    </lsq-select>
                </div>
            </div>
            <div class="invite-error" *ngIf="formGroup.errors?.err">
                {{ formGroup.errors?.err }}
            </div>
        </div>
    </form>`
})
export class InviteProspectModalComponent {
    public formGroup: FormGroup;
    public filterOptions: string[] = [];
    public contactTypeDisabled: boolean = true;

    constructor(private _modalService: ModalService) {
        this.formGroup = this._modalService.modal.data.formGroup;
    }
    public async ngOnInit(): Promise<void> {
        const prospectSchemas = await this._modalService.modal.data.schemaResponse.toPromise();
        var contactTypeOptions: ISelectOption[] = [];
        const regex = /register/;
        for (const schema of prospectSchemas) {
            if (schema.showInvitation && regex.test(schema.id))
                contactTypeOptions.push({
                    label: schema.title,
                    value: schema.id
                });
        }
        this.formGroup.value.contactTypeOptions = contactTypeOptions;
        this.filterOptions = this.formGroup.value.contactTypeOptions;
        this.contactTypeDisabled = false;
    }
}
